import { Button, Card, Col, Modal, Row, Form, Input } from "antd";
import axios from "axios";
import { useState } from "react";

export const Interested = () => {
  //more modal in the event local storage is null
  const [isModalOpen, setIsModalOpen] = useState(false);

  const FormMoreInformation = () => {
    const [form] = Form.useForm();

    return (
      <Modal
        open={isModalOpen}
        title="Reuqest More Information"
        closeIcon
        footer={[
          <Button
            key="link"
            type="primary"
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  postEmailMoreInformation(values);
                  postDiscordMessageInterested(values);
                  form.resetFields();
                })
                .catch((info) => {
                  console.log("Validate Failed:", info);
                });
            }}
          >
            Request Info
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" name="form_in_modal">
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true,
                message: "Please input the title of collection!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                message: "Please input the title of collection!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="number"
            label="Phone Number"
            rules={[
              {
                required: false,
                message: "Please input your phone number!",
              },
            ]}
          >
            <Input
              style={{
                width: "100%",
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  //check userinformation in local storage if not present request information
  const success = (_, values) => {
    Modal.success({
      content: `Thanks ${values.name} - Will be in touch!`,
    });
  };
  const postDiscordMessageInterested = async (values) => {
    return axios
      .post(".netlify/functions/postDiscordMessagePitchInterested", {
        values,
      })
      .then((response) => {
        success(response, values);
      })
      .catch(function error(error) {
        const errorMessage = error.response.data;
        console.log(errorMessage);
      });
  };

  const postEmailMoreInformation = async (values) => {
    return axios
      .post(".netlify/functions/postEmailMoreInformation", {
        values,
      })
      .then((response) => {
        setIsModalOpen(false);
        console.log(response);
      })
      .catch(function error(error) {
        const errorMessage = error.response.data;
        console.log(errorMessage);
      });
  };

  const localRequest = (values) => {
    postEmailMoreInformation(values);
    postDiscordMessageInterested(values);
  };

  return (
    <Card
      style={{ backgroundColor: "#f2b823", color: "white", maxWidth: "1050px" }}
    >
      <Row gutter={[18, 18]}>
        <FormMoreInformation />
        <Col xs={24} sm={24} md={12}>
          <h4>I'm interested, tell me more</h4>
          <p>
            {
              "Hit the button, enter your contact details and a message, we'll get right back to you!"
            }
          </p>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Button
              style={{
                color: "#f2b823",
                fontSize: "16px",
                // width: "50%",
              }}
              size="large"
              shape="round"
              onClick={() => {
                const values = JSON.parse(localStorage.getItem("user"));
                values ? localRequest(values) : setIsModalOpen(true);
              }}
            >
              Send me more information!
            </Button>
          </div>
        </Col>
      </Row>
    </Card>
  );
};
